import PropTypes from 'prop-types';
import React, { useState } from 'react';

export const Image = props => {
  const { src, alt, ...rest } = props;

  const [imageLoaded, setImageLoaded] = useState(true);

  if (!src || !imageLoaded) return null;

  const onErrorInImageLoad = () => setImageLoaded(false);

  return (
    <img
      src={src}
      alt={alt}
      {...rest}
      loading="lazy"
      onError={onErrorInImageLoad}
    />
  );
};

Image.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  height: PropTypes.string,
  width: PropTypes.string,
  className: PropTypes.string,
};
